/**
 * @description 导出默认主题配置
 */
const theme = {
  //横纵布局 horizontal vertical
  layout: 'vertical',
  //是否开启主题配置按钮
  themeBar: true,
  //布局风格
  style: 'light',
  //主题色
  themeColor: '#2F54EB',
}
module.exports = theme
